import ClasImpl from '@/serviceImpl/ClasImpl';
import {FilteredPrecinctsType, FilterGroup} from '@/domain/services/Clas';
import {getCredentialsOrThrow} from '@/domain/useCases/getCredentialsOrThrow';

const getFilteredPrecinctsUseCase = async (filterGroup: FilterGroup, year?: number): Promise<FilteredPrecinctsType | undefined> => {
  const accessToken = getCredentialsOrThrow();

  if(!year) return;

  try {
    return await ClasImpl.getFilteredPrecincts(year, filterGroup, accessToken);
  } catch (error) {
    console.error('Unknown error fetching filtered precincts', error);
    throw error;
  }

};

export default getFilteredPrecinctsUseCase;